import createProps from '@kissui/helpers/src/props.helpers'
import { projectHasNextSibling } from '@kissui/helpers/src/dataset.helpers'

class Hero extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
        this.setExtraPaddingForPlpFilter()
    }

    render() {
        const {
            campaign = {},
            campaign_id = '',
            campaign_name = '',
            campaign_position = '',
            campaign_creative = '',
            contrast,
            padding_top = 'pt9',
            padding_bottom = 'pb9',
            heading = '',
            sub_heading = '',
            a11y_heading = '',
            description = '',
            background_retina = '',
            background_desktop = '',
            background_mobile = ''
        } = this.props
        const { id = '', name = '', position = '', creative = '' } = campaign

        this.innerHTML = `
            <nb-container
                contrast='${contrast}'
                classname='${padding_top} ${padding_bottom}'
                background_mobile='${background_mobile}'
                background_desktop='${background_desktop}'
                background_retina='${background_retina}'
                campaign_id='${id ? id : campaign_id}'
                campaign_name='${name ? name : campaign_name}'
                campaign_position='${position ? position : campaign_position}'
                campaign_creative='${creative ? creative : campaign_creative}'
                lazy_load="false"
            >
                ${sub_heading && `<h3>${sub_heading}</h1>`}
                ${heading && `<h1 class='h-3xl-700'>${heading}</h1>`}
                ${a11y_heading && `<span class='sr-only'>${a11y_heading}</span>`}
                ${description && `<p class='t-md-400-sl'>${description}</p>`}
            </nb-container>
        `
    }

    setExtraPaddingForPlpFilter() {
        if (projectHasNextSibling(this, 'nb-plp')) {
            this.classList.add('hasPlpAfter')
        }
    }
}

customElements.get('nb-hero') || customElements.define('nb-hero', Hero)

export default Hero
